<template>
    <div v-loading="dataLoading">
        <!-- 地区分布：省份 + 城市（表格 / 柱状图切换） -->
        <el-card class="box-card" v-if="data && data.provinceList">
            <div slot="header" class="clearfix">
                <span>
                    <span class="el-icon-data-line"></span> 地区分布 <span class="color-danger">（按用户秀动标签所在经常所在城市取值，若取值失败或无法统计则统一归为【未知】）</span>
                </span>
                <!-- 表格/柱状图展示切换，默认表格 -->
                <div class="fr">
                    <el-radio-group v-model="regionView" size="mini" @change="changeRegionView">
                        <el-radio-button label="table">
                            <el-tooltip content="表格展示" placement="top"><i class="el-icon-s-grid"></i></el-tooltip>
                        </el-radio-button>
                        <el-radio-button label="bar">
                            <el-tooltip content="柱状图展示" placement="top"><i class="el-icon-s-data"></i></el-tooltip>
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <template v-if="regionView === 'table'">
                <div class="page-list-box">
                    <el-table :data="data.provinceList" border style="width: 100%" size="small" stripe max-height="400">
                        <el-table-column prop="name" label="省份"></el-table-column>
                        <el-table-column prop="num" label="人数"></el-table-column>
                        <el-table-column prop="ratio" label="占比"></el-table-column>
                    </el-table>
                </div>
                <div class="page-list-box">
                    <el-table :data="data.cityList" border style="width: 100%" size="small" stripe max-height="400">
                        <el-table-column prop="name" label="城市"></el-table-column>
                        <el-table-column prop="num" label="人数"></el-table-column>
                        <el-table-column prop="ratio" label="占比"></el-table-column>
                    </el-table>
                </div>
            </template>
            <template v-else>
                <div id="collectProvinceChart"></div>
                <div id="collectCityChart"></div>
            </template>
        </el-card>
        <!-- 年龄分布：柱状图 -->
        <el-card class="box-card MT20" v-if="data && data.ageList">
            <div slot="header" class="clearfix">
                <span>
                    <span class="el-icon-data-line"></span> 年龄分布
                </span>
            </div>
            <div id="collectAgeChart"></div>
        </el-card>
        <!-- 新老用户：饼图 -->
        <el-card class="box-card MT20" v-if="data && data.userList">
            <div slot="header" class="clearfix">
                <span>
                    <span class="el-icon-data-line"></span> 新老用户 <span class="color-danger">（演出上线时间前注册为老用户，演出上线时间后注册为新用户）</span>
                </span>
            </div>
            <div id="collectUserChart"></div>
        </el-card>
        <!-- 性别分布：饼图 -->
        <el-card class="box-card MT20" v-if="data && data.sexRatio">
            <div slot="header" class="clearfix">
                <span>
                    <span class="el-icon-data-line"></span> 性别分布 <span class="color-danger">（性别统计以用户账号实名性别为准，若用户未完成账号实名或其他原因导致无法统计，视为未知）</span>
                </span>
            </div>
            <div id="collectSexChart"></div>
        </el-card>
    </div>
</template>

<script>
import { Chart } from '@antv/g2';
export default {
    props: {
        activityId: {
            type: [Number, String],
            default: () => null
        },
        haveEditAudit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dataLoading: false,
            data: null,
            chartAge: null, // 年龄分布图表实例
            chartUser: null, // 新老用户图表实例
            chartSex: null, // 性别分布图表实例
            regionView: 'table', // 地区分布展示方式：table表格（默认）/ bar柱状图
            chartProvince: null, // 省份分布柱状图实例
            chartCity: null // 城市分布柱状图实例
        }
    },
    mounted() {
        this.getDatalist()
    },
    methods: {
        //获取收藏用户画像数据
        getDatalist() {
            this.dataLoading = true;
            this.$request({
                url: "/activity/statistics/collectUserPortrait",
                params: { id: parseInt(this.activityId) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result
                        if (this.data.ageList && this.data.ageList.length > 0) {
                            this.$nextTick(() => {
                                this.drawAgeChart();
                            })
                        }
                        if (this.data.userList && this.data.userList.length > 0) {
                            this.$nextTick(() => {
                                this.drawUserChart();
                            })
                        }
                        if (this.data.sexRatio && this.data.sexRatio.length > 0) {
                            this.$nextTick(() => {
                                this.drawSexChart();
                            })
                        }
                        //当前为柱状图模式时，数据更新后重绘地区分布
                        if (this.regionView === 'bar') {
                            this.$nextTick(() => {
                                this.drawRegionCharts();
                            })
                        }
                    } else {
                        this.$message.error(msg || "获取数据失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取数据失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //切换地区分布展示方式：表格 / 柱状图
        changeRegionView(val) {
            if (val === 'bar') {
                this.$nextTick(() => {
                    this.drawRegionCharts();
                })
            } else {
                this.destroyRegionCharts();
            }
        },
        //销毁地区分布柱状图
        destroyRegionCharts() {
            if (this.chartProvince) {
                this.chartProvince.destroy();
                this.chartProvince = null;
            }
            if (this.chartCity) {
                this.chartCity.destroy();
                this.chartCity = null;
            }
        },
        //绘制地区分布柱状图（省份、城市）
        drawRegionCharts() {
            this.destroyRegionCharts();
            this.chartProvince = this.createBarChart('collectProvinceChart', this.data.provinceList);
            this.chartCity = this.createBarChart('collectCityChart', this.data.cityList);
        },
        //创建柱状图：name 名称、num 人数、ratio 占比
        createBarChart(container, list) {
            const _data = (list || []).map(v => {
                return { ...v, num: parseFloat(v.num) }
            });

            const chart = new Chart({
                container: container,
                autoFit: true,
                height: 320,
            });
            chart.data(_data);
            chart
                .interval()
                .position('name*num')
                .color('name')
                .tooltip('name*num*ratio', function (name, num, ratio) {
                    return { name, num, ratio };
                });
            chart.axis('name', {
                label: {
                    autoHide: true,
                    autoRotate: true,
                },
            });
            chart.legend(false);
            chart.tooltip({
                showTitle: false,
                showMarkers: false,
                position: 'right',
                itemTpl: `<div style="margin-bottom: 10px;">
                    <span style="background-color:{color};" class="g2-tooltip-marker"></span>
                    <span style="margin-right:10px"> {name}，人数：{num}，占比：{ratio}</span>
                </div>`,
            });
            chart.render();
            return chart;
        },
        //年龄分布柱状图
        drawAgeChart() {
            if (this.chartAge) this.chartAge.destroy();

            const _data = [...this.data.ageList];
            _data.map(v => {
                v.num = parseFloat(v.num)
            })

            this.chartAge = new Chart({
                container: 'collectAgeChart',
                autoFit: true,
                height: 200,
            });
            this.chartAge.data(_data);
            this.chartAge.interaction('active-region');
            this.chartAge.tooltip({
                showTitle: false, //不显示标题
                showMarkers: false, //不显示贴附上去的小点
                position: "right", //显示位置
                itemTpl: `<div  style="margin-bottom: 10px;">
                    <span style="background-color:{color};" class="g2-tooltip-marker"></span>
                    <span style="margin-right:10px"> {name}，人数：{num}，占比：{ratio}</span>
                </div>`,
            });
            this.chartAge.interval().position("name*num").tooltip("name*num*ratio", function (name, num, ratio) {
                return { name, num, ratio };
            });
            this.chartAge.render();
        },
        //新老用户饼图
        drawUserChart() {
            if (this.chartUser) this.chartUser.destroy();

            let _data = [...this.data.userList];
            _data.map(v => {
                v.percent = v.num
            })
            _data = _data.filter(v => v.num > 0);

            this.chartUser = new Chart({
                container: 'collectUserChart',
                autoFit: true,
                height: 420,
            });
            this.chartUser.coordinate('theta', {
                radius: 0.6,
            });
            this.chartUser.data(_data);
            this.chartUser.scale('percent', {
                formatter: (val) => {
                    val = (val * 100).toFixed(2) + '%';
                    return val;
                },
            });
            this.chartUser.tooltip({
                showTitle: false,
                showMarkers: false,
            });
            this.chartUser.legend('name', {
                position: 'top',
            });
            this.chartUser
                .interval()
                .adjust('stack')
                .position('percent')
                .color('name')
                .label('percent', () => {
                    return {
                        content: (obj) => {
                            return obj.name + '：（人数：' + obj.num + ' 占比：' + obj.ratio + '）';
                        },
                    };
                })
                .tooltip('name*num*percent', (name, num, percent) => {
                    return {
                        name: name,
                        value: percent,
                    };
                });
            this.chartUser.render();
        },
        //性别分布饼图
        drawSexChart() {
            if (this.chartSex) this.chartSex.destroy();

            let _data = [...this.data.sexRatio];
            _data.map(v => {
                v.percent = v.num
            })
            _data = _data.filter(v => v.num > 0);

            this.chartSex = new Chart({
                container: 'collectSexChart',
                autoFit: true,
                height: 420,
            });
            this.chartSex.coordinate('theta', {
                radius: 0.6,
            });
            this.chartSex.data(_data);
            this.chartSex.scale('percent', {
                formatter: (val) => {
                    val = (val * 100).toFixed(2) + '%';
                    return val;
                },
            });
            this.chartSex.tooltip({
                showTitle: false,
                showMarkers: false,
            });
            this.chartSex.legend('name', {
                position: 'top',
            });
            this.chartSex
                .interval()
                .adjust('stack')
                .position('percent')
                .color('name')
                .label('percent', () => {
                    return {
                        content: (obj) => {
                            return obj.name + '：（人数：' + obj.num + ' 占比：' + obj.ratio + '）';
                        },
                    };
                })
                .tooltip('name*num*ratio', (name, num, ratio) => {
                    return {
                        name: name,
                        num: num,
                        value: num,
                    };
                });
            this.chartSex.render();
        }
    }
}
</script>
